export default __webpack_public_path__ + "static/media/banner-transbrasil-mobile2.c0f55575.png";